export default defineNuxtPlugin((nuxtApp) => {
	const runtimeConfig = useRuntimeConfig()
	const { $apiHelper } = useNuxtApp()

	const buildApiUrl = (appendPath) => {
		return runtimeConfig.public.SERVICES.MOTHERSHIP_API_URL + "credentials/" + appendPath
	}

	nuxtApp.provide("credentialApiService", {
		$transfer: async (requestBody, successHandler) => {
			const url = buildApiUrl("transfer")

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$claim: async (requestBody, successHandler) => {
			const url = buildApiUrl("claim")

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},

		$unclaim: async (requestBody, successHandler) => {
			const url = buildApiUrl("unclaim")

			const requestOptions = {}
			requestOptions.method = "POST"
			requestOptions.headers = $apiHelper.$authedRequestHeader()
			requestOptions.body = requestBody

			$apiHelper.$performRequest(url, requestOptions, successHandler)
		},
	})
})
